import React, {Component} from 'react';
import {Input, Modal, ModalFooter, ModalHeader} from "reactstrap";

export class Switch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: this.props.isOpen,
        };

        this.toggle = this.toggle.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleAccept() {
        this.toggle()
    }

    handleCheckboxChange(event) {
        event.stopPropagation();
        this.props.onChange(event);
        if (event.target.checked)
            this.toggle();
    }

    getModalClassName() {
        if (this.props.className)
            return this.props.className
        else
            return "modal-body"
    }

    getModalIfNeeded() {
        if (this.props.messageToAlertUserIfChecked) {
            return (
                <Modal key="modal" isOpen={this.state.modal} toggle={this.toggle} className={this.getModalClassName()}>
                    {this.renderModalHeader()}
                    <div className="modal-section">
                        <p>{this.props.messageToAlertUserIfChecked}<br/><br/></p>
                    </div>
                    <ModalFooter>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            clear: "both"
                        }}>
                            <div style={{margin: "0 10px"}}><input onClick={this.handleAccept} type="button"
                                                                   value="Entendido" className="btn -alt"/></div>
                        </div>
                    </ModalFooter>
                </Modal>)
        }

        return null
    }

    renderModalHeader() {
        if (this.props.title)
            return <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
    }

    getTextJustForCentered(someText) {
        return this.props.centered === true ? someText : "";
    }

    getStyle() {
        const centeredStyle = this.props.centered ? { marginTop: "10px" } : {};
        return { ...centeredStyle, ...this.props.style };
    }

    renderTextPart() {
        return null;
        // return <p className="mb-0">Objetivo </p>
    }

    getClassName() {
        return this.props.className !== undefined ? this.props.className : null;
    }


    render() {
        const modal = this.getModalIfNeeded()

        const ret = [
            <label 
                key="switch-label"
                className={"switch "+ this.getTextJustForCentered("me-2 ") + this.getClassName()}
                style={this.getStyle()}
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
            >
                    <Input
                        type="checkbox"
                        onChange={this.handleCheckboxChange}
                        checked={this.props.checked}
                        name={this.props.name}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <span className="slider"></span>
            </label>];

        if(modal !== null || this.renderTextPart() !== null) {
            ret.push(<div key="switch-modal-container">
                <p className="mb-0">{modal}</p>
                <p className="mb-0">{this.renderTextPart()}</p>
            </div>);
        }

        return ret;
    }
}

